export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_02-f102846c1d4489e1c0fd81c3e4b586a4.jpg";